import React from 'react';

import {DEFAULT_PLATE_SIZE, PLATE_SIZE_OPTIONS} from 'notebook/tables/TableConstants';
import {useCloseableDropdownContext} from 'ui-library/dropdowns/CloseableDropdownContext';
import Option from 'ui-library/menus/Option';

interface InsertWellPlateMenuProps {
  insertWellPlateWithDimensions: (numRows: number, numCols: number) => void;
}

/**
 * A light-weight React component that renders a menu for selecting well-plate dimensions.
 * The default plate size starts highlighted.
 */

export default function InsertWellPlateMenu({
  insertWellPlateWithDimensions,
}: InsertWellPlateMenuProps): JSX.Element {
  const {onCloseDropdown} = useCloseableDropdownContext();
  const [hasHovered, setHasHovered] = React.useState(false);
  return (
    <>
      {PLATE_SIZE_OPTIONS.map(([y, x], i) => (
        <Option
          key={i}
          value={[y, x]}
          isHovered={
            !hasHovered && y === DEFAULT_PLATE_SIZE[0] && x === DEFAULT_PLATE_SIZE[1] ? true : undefined
          }
          onHover={() => {
            setHasHovered(true);
          }}
          onSelect={() => {
            insertWellPlateWithDimensions(y, x);
            onCloseDropdown();
          }}
          disableEventPropagation={true}
        >
          {`${x * y}-well plate (${y} x ${x})`}
        </Option>
      ))}
    </>
  );
}
